(() => {
  const sectionSelector = '#MainContent .shopify-section';
  const targetSelector = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'p',
    '.rte > *',
    '.button',
    'button',
    'a[href]',
    'img',
    'picture',
    '.grid__item',
    '.card-wrapper',
    '.card',
    '.collection-list__item',
    '.product-card-wrapper',
    '.slider__slide',
    '[class*="__card"]',
    '[class*="__item"]',
    '[class*="__media"]',
    '[class*="__image"]',
    '[class*="__content"]',
  ].join(',');

  const ignoredSelector = [
    'script',
    'style',
    'noscript',
    'template',
    '[hidden]',
    '.visually-hidden',
    '.skip-to-content-link',
    '.shopify-section-header-sticky',
    '.slider-button',
    '.slider-counter',
    '.slideshow__controls',
    '.modal',
    'modal-dialog',
    'details',
    'summary',
  ].join(',');

  let observer;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isVisibleCandidate(element) {
    if (!element || element.matches(ignoredSelector) || element.closest(ignoredSelector)) return false;
    if (element.closest('[aria-hidden="true"], .hidden, .no-js-hidden')) return false;

    const rect = element.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return false;

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function hasAnimatedAncestor(element, section) {
    let parent = element.parentElement;
    while (parent && parent !== section) {
      if (parent.classList.contains('tcs-home-stagger-item')) return true;
      parent = parent.parentElement;
    }
    return false;
  }

  function collectTargets(section) {
    const all = Array.from(section.querySelectorAll(targetSelector)).filter(isVisibleCandidate);
    const preferred = all.filter((element) => {
      if (element.matches('a[href]') && element.closest('.button, button')) return false;
      if (element.matches('img, picture') && element.closest('.card, .card-wrapper, .grid__item, .slider__slide')) return false;
      return !hasAnimatedAncestor(element, section);
    });

    return preferred.slice(0, 36);
  }

  function resetSection(section) {
    section.querySelectorAll('.tcs-home-stagger-item').forEach((element) => {
      element.classList.remove('tcs-home-stagger-item', 'tcs-home-stagger-visible', 'tcs-home-stagger-soft');
      element.style.removeProperty('--tcs-stagger-index');
    });
  }

  function prepareSection(section) {
    resetSection(section);

    const targets = collectTargets(section);
    targets.forEach((element, index) => {
      element.classList.add('tcs-home-stagger-item');
      if (element.matches('img, picture, [class*="__media"], [class*="__image"]')) {
        element.classList.add('tcs-home-stagger-soft');
      }
      element.style.setProperty('--tcs-stagger-index', Math.min(index, 18));
    });

    return targets;
  }

  function reveal(element) {
    element.classList.add('tcs-home-stagger-visible');
  }

  function init(root = document) {
    document.documentElement.classList.add('tcs-home-stagger-enabled');

    if (observer) observer.disconnect();
    const sections = Array.from(root.querySelectorAll(sectionSelector));
    const targets = sections.flatMap(prepareSection);

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );

    targets.forEach((element) => observer.observe(element));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => window.setTimeout(() => init(), 80));
  document.addEventListener('shopify:section:reorder', () => window.setTimeout(() => init(), 80));
})();
